



















































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

export interface CustomerStatsRow {
  customerName: string;
  stationCount: number;
  openMaintenanceCount: number;
  overdueMaintenanceCount: number;
}

interface RankedCustomerRow extends CustomerStatsRow {
  rank: number;
}

@Component({})
export default class MaintenanceByCustomerTableComponent extends Vue {
  @Prop({ default: () => [] }) rows!: CustomerStatsRow[];
  @Prop({ default: false }) loading!: boolean;
  @Prop({ default: 5 }) itemsPerPage!: number;

  public page = 1;

  @Watch('rows')
  onRowsChange() {
    this.page = 1;
  }

  private get rankedRows(): RankedCustomerRow[] {
    return this.rows.map((row, index) => ({
      ...row,
      rank: index + 1,
    }));
  }

  private get paginatedRows(): RankedCustomerRow[] {
    const start = (this.page - 1) * this.itemsPerPage;
    return this.rankedRows.slice(start, start + this.itemsPerPage);
  }

  private get pageCount(): number {
    return Math.max(1, Math.ceil(this.rows.length / this.itemsPerPage));
  }

  private get pageStart(): number {
    if (!this.rows.length) return 0;
    return (this.page - 1) * this.itemsPerPage + 1;
  }

  private get pageStop(): number {
    return Math.min(this.page * this.itemsPerPage, this.rows.length);
  }

  private get currentPageRowCount(): number {
    if (this.loading) return this.itemsPerPage;
    if (!this.rows.length) return 1;
    return this.paginatedRows.length;
  }

  private get tableHeight(): number {
    const rowHeight = 58;
    const footerHeight = this.rows.length ? 34 : 0;
    return this.currentPageRowCount * rowHeight + footerHeight;
  }
}
